// 🎯 Página principal para los detalles de órdenes de ubicación - Main page for location order details
import React from 'react';
import { DetailContainer } from './components/containers/DetailContainer';

export const Detail: React.FC = () => {
  return <DetailContainer />;
};
